module.exports = __webpack_public_path__ + "static/media/ci_external-link.2d262d42.svg";